exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".addStudentsClassCode{padding-left:25px;padding-right:25px}.addStudentsClassCode .classCodeTable.table{margin-top:20px;margin-bottom:25px}.addStudentsClassCode .classCodeTable.table tr{border-bottom:1px solid #ddd}.addStudentsClassCode .classCodeTable.table td.link a{font-size:.8em}.addStudentsClassCode .classCodeTable.table td,.addStudentsClassCode .classCodeTable.table th{padding:2px 8px;min-width:7.5em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/org/roster_upload/add_students_class_code.scss
// module id = 1369
// module chunks = 0